<template>
  <section v-if="isGetCollectionRequestPending">
    <p-loading />
  </section>
  <section v-else class="users">
    <div class="user-list-wrapper">
      <div class="header-wrapper">
        <div>
          <router-link v-if="$hasPermission('users')" to="people/new">+&nbsp;add new</router-link>
        </div>
        <div><label>Total:</label>&nbsp;{{ total }}</div>
      </div>
      <ul class="user-list">
        <li class="user-list-item header">
          <!-- <div>Id</div> -->
          <div>Email</div>
          <div>Fullname</div>
          <div>Registration Number(s)</div>
          <div>Customer Number(s)</div>
          <div>Created At</div>
          <div>Updated At</div>
          <div class="action-link-wrapper"></div>
        </li>
      </ul>
      <ul class="user-list">
        <li v-for="entry in collection" :key="entry.id" class="user-list-item">
          <!-- <div>{{ entry.id }}</div> -->
          <div class="user-email">
            <div><p-icon v-if="entry.isBot" name="robot" class="robot-icon" title="This is a bot user" /></div>
            <div>{{ entry.email }}</div>
          </div>
          <div>{{ entry.firstName }}&nbsp;{{ entry.lastName }}</div>
          <div>
            <span v-if="isGetPortfolioAuthorizationRequestPending"></span>
            <span v-else>{{ getRegistrationNumbers(entry.email) }}</span>
          </div>
          <div>
            <span v-if="isGetPortfolioAuthorizationRequestPending"></span>
            <span v-else>{{ getCustomerNumbers(entry.email) }}</span>
          </div>
          <div>{{ entry.createdAt && new Date(entry.createdAt).toLocaleString() }}</div>
          <div>{{ entry.updatedAt && new Date(entry.updatedAt).toLocaleString() }}</div>
          <div class="action-link-wrapper">
            <router-link :to="`people/${entry.id}`">&#9998;</router-link>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import Loading from '@/components/common/Loading';
import Icon from '@/components/common/Icon';

export default {
  components: {
    'p-loading': Loading,
    'p-icon': Icon
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      total: (s) => s.users.collection.length,
      collection: (s) => s.users.collection,
      isGetCollectionRequestPending: (s) => s.users.isGetCollectionRequestPending,

      portfolioAuthorization: (s) => s.portfolio.users.collection,
      isGetPortfolioAuthorizationRequestPending: (s) => s.portfolio.users.isGetCollectionRequestPending
    }),
    customerNumbers(email) {
      return email;
    }
  },
  watch: {
    $route: {
      handler() {
        this.$store.dispatch('users/getCollection');
        this.$store.dispatch('portfolio/users/getCollection');
      },
      immediate: true
    }
  },
  methods: {
    getCustomerNumbers(email) {
      const item = this.portfolioAuthorization.find((p) => p.email === email);
      if (item?.customerNumbers?.length) {
        return item.customerNumbers.join(', ');
      }
      return '-';
    },
    getRegistrationNumbers(email) {
      const item = this.portfolioAuthorization.find((p) => p.email === email);
      if (item?.registrationNumbers?.length) {
        return item.registrationNumbers.join(', ');
      }

      return '-';
    }
  }
};
</script>

<style lang="scss" scoped>
.users {
  display: grid;
  padding: 1rem 1rem 0 1rem;
  width: 100%;

  .user-list-wrapper {
    display: grid;
    grid-template-rows: 20px max-content minmax(0, 1fr);

    .header-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 0.75rem;
      margin: 0;
      padding: 0;
      font-weight: 400;
      margin-right: 6px;
      label {
        font-weight: 500;
      }

      > * {
        &:not(:last-child) {
          margin-right: 0.5rem;
        }
      }
    }
  }

  .user-list {
    margin: 0;
    padding: 0;
    list-style: none;

    .user-list-item {
      display: grid;
      grid-template-columns: minmax(250px, 1fr) minmax(250px, 1fr) minmax(100px, 1fr) minmax(100px, 2fr) 150px 150px 30px;
      grid-gap: 0;
      border-bottom: 1px solid var(--theme-highlight);
      font-size: 0.75rem;
      align-items: center;

      > * {
        padding: 0.5rem 0.5rem;
        border-left: 1px solid var(--theme-highlight);

        &:last-child {
          border-right: 1px solid var(--theme-highlight);
        }
      }

      &:first-child {
        border-top: 1px solid var(--theme-highlight);
      }

      &.header {
        font-size: 0.75rem;
        color: var(--theme-on-background-accent);
        > * {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          padding: 0.25rem 0.5rem;
        }
      }

      .action-link-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        border-left-color: transparent;

        > * {
          opacity: 0;
        }
      }

      .user-email {
        display: flex;
        align-items: center;

        .robot-icon {
          margin-right: 5px;
          align-content: center;
        }
      }

      &:hover {
        background-color: var(--theme-highlight);
        .action-link-wrapper {
          > * {
            opacity: 1;
          }
        }
      }
    }

    &:not(:last-child) {
      margin-right: 6px;
    }

    &:last-child {
      overflow-y: scroll;
    }
  }
}
</style>
